import React from "react";
import RowData from "./RowData";

const CalendarDay = (props) => {
    const {day,calendarData} = props;
    return(
        <td>
            <div className="calendar-data">
                <div className="data-caption">
                    <span className="total-emails">{(Object.keys(calendarData).length && typeof calendarData?.schedule[day] !== 'undefined') ? calendarData?.schedule[day].total_count:0} emails</span>
                </div>
                <div className="data-rows">
                {Object.keys(calendarData).length && ((typeof calendarData?.schedule[day] !== 'undefined' && typeof calendarData?.schedule[day].slots === 'object') && (calendarData?.schedule[day].slots).map((row,i)=>{
                    return(<RowData key={i} item={row} legends={calendarData.legends} campaign={calendarData.campaign} />);
                }))}    
                </div>
            </div>
        </td>
    );
}

export default CalendarDay;